import React from "react";
import {Link} from "react-router-dom";
import {List, ListItem, Popover, OverlayTrigger} from "@deere/ux.uxframe-react";
import {Box, Grid, Typography} from '@deere/fuel-react';

export const Team = ({team}) => {
    const teamMembersList = team.teamMembers.map(item => item.name)
    const getDisplayList = (startIndex) => {
        let listItems = [];
        for (let i = startIndex; i < teamMembersList.length; i++) {
            listItems.push(<ListItem key={i}>{teamMembersList[i]}</ListItem>);
        }
        return <List variant="uxf-ul">{listItems}</List>;
    }

    return (
        <ListItem className="list-group-item mb-1" style={{borderRadius: "0.25rem"}} key={team.supplierNumber}>
            <Grid container>
                <Grid item xs={12}>
                    <Link
                        to={{
                            pathname: `/rating-teams/view-team/${team.supplierNumber}`,
                        }}>
                        {team.functionalAreaType} - {team.supplierNumber} - {team.supplierName.toUpperCase()}
                    </Link>
                </Grid>
                <Grid item xs={12} md={8}>
                    <Typography fontWeight="bold" component="p" display="inline">
                        Team Members
                    </Typography>
                    <Typography size="sm" component="span" color="tertiary">
                        &nbsp; {teamMembersList && teamMembersList.length > 0 && (
                        <>
                            {teamMembersList && teamMembersList.length === 1 && (
                                <>
                                    {teamMembersList[0]}
                                </>
                            )}
                            {teamMembersList && teamMembersList.length > 1 && (
                                <>
                                    {teamMembersList[0] + "; " + teamMembersList[1] + " "}&nbsp;&nbsp;&nbsp;&nbsp;
                                </>
                            )}
                            {teamMembersList.length > 2 && (
                                <OverlayTrigger
                                    rootClose={true}
                                    overlay={
                                        <Popover>
                                            <Popover.Content>{getDisplayList(2)}</Popover.Content>
                                        </Popover>
                                    }
                                >
                                        <span className="popover-underline">
                                            +{teamMembersList.length - 2} more
                                        </span>
                                </OverlayTrigger>
                            )}
                        </>
                    )}
                    </Typography>
                </Grid>
                <Grid item xs={12} md={4}>
                    <Box display="flex" justifyContent="flex-end">
                        <Typography size="md" fontWeight="bold" component="p" display="inline">
                            Team Leader &nbsp;
                        </Typography>
                        <Typography size="md" fontWeight="regular" component="p" display="inline">
                            {team.teamLeader === "" ? "N/A" : team.teamLeader}
                        </Typography>
                    </Box>
                </Grid>
            </Grid>
        </ListItem>
    );
}